import React, { Component } from 'react';
import { render } from 'react-dom';
import {connect} from "react-redux";
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import CustomerData from '../../model/account/CustomerData';;
import {updateHierarchy} from "./../../actions/CustomerActions"
import {updateUser} from "./../../actions/UserActions";
import {withStyles} from '@material-ui/core/styles';

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
  },
  menu: {
    width: 200,
  },
  button: {
    textTransform: "initial",
    color: "white",
  },
  marginPaymentMethod: {
    margin: "1em 15em",
  },
  
  justifyContent: {
    margin: "22px 22px"
  }

});

@connect(store => {
	return {
  customer: store.customer.customer
}})

class CoordinateDialog extends React.Component {
  state = {
    open: false,
    customerData: {},
    title: ''
  };

  updateUserPassword = (event) => {
		event && event.preventDefault();
    let {customerData} = this.state;
		const {userName, email, password} = customerData || {};
    const user = {
			username: userName,
			email,
			password,
			externalRole : [{"name":"CC_ADMIN"}]
		};
		this.props.dispatch(updateUser(user))
    this.setState({ open: false });
	}


  handleClickOpen = (event) => {
    event && event.preventDefault();
    const {customerAccount, button, messages} = this.props;
    const customerAccountData = new CustomerData(customerAccount);
    this.setState({ open: true, customerData: customerAccountData });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleChange = (event) => {
    event && event.preventDefault();
    let {customerData} = this.state;
    const fieldName = !!event && !!event.target && event.target.name;
    customerData[fieldName] =  event.target.value
    fieldName === "title" && this.setState({title: event.target.value});
    this.setState({customerData:customerData});
  };

  updateHierarchy = (e) => {
      const {customerData} = this.state
      this.props.dispatch(updateHierarchy(customerData))
      this.setState({ open: false });
  };

  updateCustomer = (e) => {
      const {customerData} = this.state
      this.props.dispatch(updateHierarchy(customerData))
      this.setState({ open: false });
  };

  render() {
    const {customerAccount, classes, titles, button, dialogTitle, user, messages} = this.props;
    const {firstName, lastName, title} = !!customerAccount && customerAccount.name || '';
    const {email} = !!customerAccount && !!customerAccount.contactInformation && customerAccount.contactInformation;
    const {mobile, phone} =  !!customerAccount && !!customerAccount.contactInformation && customerAccount.contactInformation;
    const {address1, address2, address3, city, zipCode} = !!customerAccount && customerAccount.address || "";
  //  const emailUser = !!user && user.email;
    return (
      <div class="text-center">
        <button className="btn btn-theme-default"  onClick={this.handleClickOpen}>{button}</button>
      {button === messages["common.label.update.details"] &&
      <Dialog
          open={this.state.open}
          onClose={this.handleClose}
           aria-labelledby="simple-dialog-title"
           maxWidth="xs"
        >
          <DialogTitle id="form-dialog-title">{dialogTitle}</DialogTitle>
          <DialogContent>
            <TextField
              inputRef={el => this.firstName = el}
              name="firstName"
              margin="dense"
              label={messages["common.label.firstName"]}
              placeholder={firstName}
              onChange={this.handleChange}
              fullWidth={true}
              disabled
              InputLabelProps={{shrink: true,}}
              inputProps={{maxLength: 255, }}
            />
            <TextField
              margin="normal"
              inputRef={value => this.lastName = value}
              name="lastName"
              disabled
              label ={messages["common.label.lastName"]}
              placeholder={lastName}
              onChange={this.handleChange}
              fullWidth={true}
              multiline
              InputLabelProps={{shrink: true,fontWeight:"blod", fontSize:"2rem"}}
              inputProps={{maxLength: 255, }}
              />
              <TextField
                autoFocus
                inputRef={value => this.email = value}
                name="email"
                disabled
                margin="dense"
                label={messages["common.label.email"]}
                placeholder={email}
                onChange={this.handleChange}
                fullWidth={true}
                InputLabelProps={{shrink: true,}}
                inputProps={{maxLength: 255, }}
              />
              <TextField
                autoFocus
                inputRef={value => this.mobile = value}
                name="mobile"
                margin="dense"
                label={messages["common.label.mobile"]}
                placeholder={mobile}
                fullWidth={true}
                onChange={this.handleChange}
                InputLabelProps={{shrink: true,}}
                inputProps={{maxLength: 10, }}
                />
              <TextField
                autoFocus
                inputRef={value => this.phone = value}
                name="phone"
                margin="dense"
                label={messages["common.label.phone"]}
                placeholder={phone}
                onChange={this.handleChange}
                fullWidth={true}
                InputLabelProps={{shrink: true,}}
                inputProps={{maxLength: 10, }}

              />


          </DialogContent>
          <DialogActions className={classes.justifyContent}>
            <Button onClick={this.handleClose} variant="contained" className={classes.button}>
                {messages["common.button.cancel"]}
            </Button>
            <Button onClick={this.updateHierarchy} variant="contained" className={classes.button}>
              {messages["common.button.validate"]}
            </Button>
          </DialogActions>
        </Dialog>
      }
      {button === messages["common.label.update.address"] &&
        <Dialog
            open={this.state.open}
            onClose={this.handleClose}
             aria-labelledby="simple-dialog-title"
             maxWidth="xs"
          >
          <DialogTitle id="form-dialog-title">{dialogTitle}</DialogTitle>
            <DialogContent>
                <TextField
                  autoFocus
                  margin="normal"
                  inputRef={value => this.address1 = value}
                  name="address1"
                  id="address1"
                  label ={messages["common.label.address1"]}
                  placeholder={address1}
                  onChange={this.handleChange}
                  fullWidth={true}
                  multiline
                  InputLabelProps={{shrink: true,'fontWeight':"blod", 'fontSize':"2rem"}}
                  inputProps={{maxLength: 100, }}
                  />
                  <TextField
                    autoFocus
                    margin="normal"
                    inputRef={value => this.address2= value}
                    name="address2"
                    id="address2"
                    label ={messages["common.label.address2"]}
                    placeholder={address2}
                    onChange={this.handleChange}
                    fullWidth={true}
                    multiline
                    InputLabelProps={{shrink: true,'fontWeight':"blod", 'fontSize':"2rem"}}
                    inputProps={{maxLength: 100, }}
                    />
                    <TextField
                      autoFocus
                      margin="normal"
                      inputRef={value => this.address3 = value}
                      name="address3"
                      id="address3"
                      label ={messages["common.label.address3"]}
                      placeholder={address3}
                      onChange={this.handleChange}
                      fullWidth={true}
                      multiline
                      InputLabelProps={{shrink: true,'fontWeight':"blod", 'fontSize':"2rem"}}
                      inputProps={{maxLength: 100, }}
                      />
                      <TextField
                        autoFocus
                        margin="normal"
                        inputRef={value => this.zipCode = value}
                        name="zipCode"
                        id="zipCode"
                        label ={messages["common.label.zipCode"]}
                        placeholder={zipCode}
                        onChange={this.handleChange}
                        fullWidth={true}
                        multiline
                        InputLabelProps={{shrink: true,'fontWeight':"blod", 'fontSize':"2rem"}}
                        inputProps={{maxLength: 10, }}
                        />
                      <TextField
                        autoFocus
                        margin="normal"
                        inputRef={value => this.address1 = value}
                        name="city"
                        id="city"
                        label ={messages["common.label.city"]}
                        placeholder={city}
                        onChange={this.handleChange}
                        fullWidth={true}
                        multiline
                        InputLabelProps={{shrink: true,'fontWeight':"blod", 'fontSize':"2rem"}}
                        inputProps={{maxLength: 100, }}
                        />
            </DialogContent>
            <DialogActions className={classes.justifyContent}>
              <Button onClick={this.handleClose} variant="contained" className={classes.button}>
                {messages["common.button.cancel"]}
              </Button>
              <Button onClick={this.updateHierarchy} variant="contained" className={classes.button}>
              {messages["common.button.validate"]}
              </Button>
            </DialogActions>
          </Dialog>
        }
        {button === messages["common.label.update.my.identifiers"] &&
          <Dialog
              open={this.state.open}
              onClose={this.handleClose}
               aria-labelledby="simple-dialog-title"
               maxWidth="xs"
            >
              <DialogTitle id="form-dialog-title">{dialogTitle}</DialogTitle>
              <DialogContent>
                <TextField
                  autoFocus
                  inputRef={el => this.email = el}
                  name="email"
                  margin="dense"
                  value={user.username}
                  label={messages["common.label.login"]}
                  disabled
                  fullwidth
                  InputLabelProps={{shrink: true,}}
                />
                <TextField
                  autoFocus
                  inputRef={el => this.password = el}
                  name="password"
                  margin="dense"
                  type = "password"
                  label={messages["common.label.password"]}
                  onChange={this.handleChange}
                  fullwidth
                  InputLabelProps={{shrink: true,}}
                />
                <TextField
                  autoFocus
                  inputRef={el => this.password_confirmation = el}
                  name="password_confirmation"
                  margin="dense"
                  type = "password"
                  label={messages["common.label.confirm.password"]}
                  onChange={this.handleChange}
                  fullwidth
                  InputLabelProps={{shrink: true,}}
                />

              </DialogContent>
              <DialogActions className={classes.justifyContent}>
                <Button onClick={this.handleClose} variant="contained" className={classes.button}>
                  {messages["common.button.cancel"]}
                </Button>
                <Button onClick={this.updateUserPassword} variant="contained" className={classes.button}>
                  {messages["common.button.validate"]}
                </Button>
              </DialogActions>
            </Dialog>
          }
      </div>
    );
  }
}
export default withStyles(styles)(CoordinateDialog);



// WEBPACK FOOTER //
// ./src/opencell/pages/client/CoordinateDialog.jsx